<template>
  <v-row>
    <!--STEPPER-->
    <v-col cols="12">
      <section id="inicio"></section>
      <v-stepper v-model="step" non-linear>
        <v-stepper-header>

          <v-stepper-step
              editable
              :step="1"
              complete-icon="inventory_2"
              edit-icon="inventory_2"
          >
            Entrega
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :editable="orderSystem.stepsReady >= 1 "
              :step="2"
              complete-icon="inventory_2"
              edit-icon="inventory_2"
          >
            Productos
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :editable="orderSystem.stepsReady >= 2"
              :step="3"
              complete-icon="call"
          >
            Contacto
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :step="4"
              :editable="orderSystem.stepsReady >= 3 "
              complete-icon="done"
          >
            Pago
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :step="5"
              :editable="orderSystem.stepsReady >= 4 "
              complete-icon="price_check"
          >
            Confirmar
          </v-stepper-step>

        </v-stepper-header>
      </v-stepper>
    </v-col>


    <v-col cols="12">
      <section id="initStep"></section>
      <v-stepper v-model="step" :elevation="0" flat class="transparent ">

        <!--ORDER-MODE-->
        <v-stepper-content :step="1" class="pa-0">
          <div class="d-flex justify-center">
            <slot name="step1"></slot>
          </div>
        </v-stepper-content>

        <!--PRODUCTS-->
        <v-stepper-content :step="2" class="pa-0">
          <slot name="step2"></slot>
        </v-stepper-content>

        <v-stepper-content :step="3" class="pa-0">
          <div class="d-flex justify-center">
            <slot name="step3"></slot>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="4" class="pa-0">
          <div class="d-flex justify-center">
            <slot name="step4"></slot>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="5" class="pa-0">
          <div class="d-flex justify-center">
            <slot name="step5"></slot>
          </div>
        </v-stepper-content>

      </v-stepper>

    </v-col>

  </v-row>
</template>

<script>


export default {
  name: "CustomerStepperOrder",
  data() {
    return {
      step: 1
    }
  },
  computed: {
    currentStep() {
      return this.step
    },
    orderSystem() {
      return this.$store.getters.orderSystem
    },
    getCategoriesMenu() {
      return this.$store.getters.getCategories.map(category => {
        return {icon: category.icon, name: category.name, ratio: 0, id: "c"+category.id}
      })
    },
  },
  watch: {
    step(step) {
      if (step === 2) {
        this.$store.commit('setExtensionEnable', true)
        this.$store.commit('setExtensionMenu', this.getCategoriesMenu)
      } else {
        this.$store.commit('setExtensionEnable', false)
        this.$store.commit('setExtensionMenu', null)
      }
    }
  },
  beforeDestroy() {
    this.$store.commit('setExtensionEnable',false)
    this.$store.commit('setExtensionMenu', null)
  },
  methods: {
    nextStep() {
      this.step++
      setTimeout(() => this.$vuetify.goTo('#initStep'), 300)
    },
    goToStep(step) {
      this.step = step
    }
  }
}
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
</style>
